/*=========================================================================================
  File Name: modulePostMutations.js
  Description: Post Module Mutations
==========================================================================================*/
import { getDefaultState } from "./modulePostState";

export default {
	// API
	SET_POSTS(state, posts) {
		state.posts = [...state.posts, ...posts];
	},

	ADD_POST(state, post) {
		state.posts = [post, ...state.posts];
	},

	UPDATE_POST(state, post) {
		const postIndex = state.posts.findIndex(t => t.id === post.id);
		if (postIndex !== -1) {
			Object.assign(state.posts[postIndex], post);
		}
	},

	TOGGLE_LIKE_POST(state, postId) {
		const postIndex = state.posts.findIndex(t => t.id === postId);
		if (postIndex !== -1) {
			Object.assign(state.posts[postIndex], {
				...state.posts[postIndex],
				liked: !state.posts[postIndex].liked,
				likes: state.posts[postIndex].liked === true ? (state.posts[postIndex].likes -= 1) : (state.posts[postIndex].likes += 1)
			});
		}
	},

	SEND_COMMENT(state, postId) {
		const postIndex = state.posts.findIndex(t => t.id === postId);
		if (postIndex !== -1) {
			Object.assign(state.posts[postIndex], {
				...state.posts[postIndex],
				totalComment: (state.posts[postIndex].totalComment += 1)
			});
		}
	},

	DELETE_POST(state, postId) {
		state.posts = state.posts.filter(post => post.id !== postId);
	},

	SET_TOTAL_POSTS(state, total) {
		state.total = total;
	},

	SET_IS_HAS_MORE_PAGES(state, isHasMorePages) {
		state.isHasMorePages = isHasMorePages;
	},

	RESET_STATE(state) {
		Object.assign(state, getDefaultState());
	},
	SET_APPELLATIONS(state, appellations) {
		state.appellations = appellations;
	},
	SET_FEATURE_POSTS(state, posts) {
		state.featurePosts = posts;
	}
};
